import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { filter } from 'lodash';
// utils
import { PURGE } from 'redux-persist';
import { formDataHeaders, headers, objectToFormData, saltmineJwtHeaders, urls } from 'src/libs/reqConf';
import { checkTokenAndRefresh, errorHandle, isExist, sortIsRead } from 'src/utils/function';
import { getCloseLoading, getLoading } from './loading';
import { getOpen, setError } from './modal';
// ----------------------------------------------------------------------
// 네트워크 기관
const initialState = {
  isLoading: false,
  notices: { docs: [], total: 0, page: 1, pages: 1, limit: 10 },
  pickNotice: {},
  selectedEventId: null,
  selectedRange: null
};

const slice = createSlice({
  name: 'notice',
  initialState,
  reducers: {
    noticeReset(state) {
      // immer를 사용하여 직접 상태를 수정
      Object.assign(state, initialState);
    },
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // GET NOTICES
    readNoticesSuccess(state, action) {
      state.isLoading = false;
      state.notices = action.payload;
    },

    // GET EVENTS
    getNoticeSuccess(state, action) {
      state.isLoading = false;
      state.pickNotice = action.payload;
    },

    // CREATE CATE
    createNoticeSuccess(state, action) {
      const newNotice = action.payload;
      state.isLoading = false;
      state.noticeList = [...state.noticeList, newNotice];
    },

    // UPDATE EVENT
    updateNoticeSuccess(state, action) {
      state.isLoading = false;
      state.noticeList = state.noticeList.map((_notice) => {
        return _notice._id === action.payload._id ? action.payload : _notice;
      });
    },

    // DELETE EVENT
    deleteNoticeSuccess(state, action) {
      const { noticeId } = action.payload;
      const deleteNotice = filter(state.noticeList, (notice) => notice.id !== noticeId);
      state.isLoading = false;
      state.noticeList = deleteNotice;
    },
    extraReducers: (builder) => {
      builder.addCase(PURGE, () => initialState);
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export const { openModal, closeModal, selectEvent, noticeReset } = slice.actions;
const accessToken = window.localStorage.getItem('accessToken');
// ----------------------------------------------------------------------

export function handleForm(status) {
  return async (dispatch) => {
    try {
      dispatch(slice.actions.handleDialog(status));
    } catch (error) {
      dispatch(getOpen(error));
    }
  };
}

// 공지사항 목록 불러오기
export function readNotices(params) {
  const { page = 1, limit = 10, search } = params || {};

  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const url = isExist(search)
        ? `${urls.service}/notices/paginate?page=${page}&limit=${limit}&search=${search}&data=isUserNotice`
        : `${urls.service}/notices/paginate?page=${page}&limit=${limit}&data=isUserNotice`;

      const config = { headers: saltmineJwtHeaders(accessToken) };
      const response = await axios.get(url, config);

      dispatch(slice.actions.readNoticesSuccess(response?.data?.data));
    } catch (error) {
      dispatch(setError(errorHandle(error)));
    }
  };
}

// ----------------------------------------------------------------------

export function readNotice(noticeId) {
  return async (dispatch) => {
    dispatch(getLoading());
    try {
      const url = `${urls.service}/notices/${noticeId}?autoMarkRead=true`;

      const config = { headers: saltmineJwtHeaders(accessToken) };
      const response = await axios.get(url, config);
      dispatch(slice.actions.getNoticeSuccess(response.data.data));
    } catch (error) {
      dispatch(getOpen(error.response.data?.message?.message));
    } finally {
      dispatch(getCloseLoading());
    }
  };
}

// ----------------------------------------------------------------------

export function createNotice(params) {
  return async (dispatch) => {
    dispatch(getLoading());
    try {
      const accessToken = await checkTokenAndRefresh(dispatch);
      const url = `${urls.user}/notice`;
      const body = objectToFormData(params);
      const config = { headers: formDataHeaders(accessToken) };
      const response = await axios.post(url, body, config);
      dispatch(slice.actions.createNoticeSuccess(response.data.data));
    } catch (error) {
      dispatch(getOpen(error.response.data?.message?.message));
    } finally {
      dispatch(getCloseLoading());
    }
  };
}

// ----------------------------------------------------------------------

export function updateNotice(noticeId, params) {
  return async (dispatch) => {
    dispatch(getLoading());
    try {
      const accessToken = await checkTokenAndRefresh(dispatch);
      const url = `${urls.user}/noticeList/${noticeId}`;
      const body = objectToFormData(params);
      const config = { headers: formDataHeaders(accessToken) };
      const response = await axios.patch(url, body, config);
      dispatch(slice.actions.updateNoticeSuccess(response.data.data));
    } catch (error) {
      dispatch(getOpen(error.response.data?.message?.message));
    } finally {
      dispatch(getCloseLoading());
    }
  };
}

// ----------------------------------------------------------------------

export function deleteNotice(noticeId) {
  return async (dispatch) => {
    dispatch(getLoading());
    try {
      const accessToken = await checkTokenAndRefresh(dispatch);
      const url = `${urls.user}/noticeList/${noticeId}`;
      const config = { headers: headers(accessToken) };
      await axios.delete(url, config);
      dispatch(slice.actions.deleteNoticeSuccess(noticeId));
      dispatch(readNotices());
    } catch (error) {
      dispatch(getOpen(error.response.data?.message?.message));
    } finally {
      dispatch(getCloseLoading());
    }
  };
}

// ----------------------------------------------------------------------
